import React, { useMemo } from "react"
import Select from "react-select"
import { DocumentTypeSelectProps } from "../../common/types"

export const DocumentTypeSelect = (props: DocumentTypeSelectProps) => {

    const handleChange = (selected) => {
        props.onChangeCallback(selected.value)
    }

    const selectOptions = useMemo(() => {
        return props.definitionListing.map(item => {
            return {
                value: item.id,
                label: item.name
            }
        })
    }, [props.definitionListing.length])

    return (
        <Select
            className={props.className ?? ""}
            menuPortalTarget={document.body}
            value={props.selectedValue}
            options={selectOptions}
            onChange={handleChange}
        />
    )
}


// WEBPACK FOOTER //
// ./src/inventory/components/DocumentTypeSelect.tsx